<template>
  <div>
    <el-dialog
      title="添加节点"
      :visible="dialogVisible"
      width="30%"
      @close="handleCloseAdd('ruleForm')">
      <div class="content">
        <el-form
        ref="ruleForm"
        :rules="rules"
        :model="ruleForm"
        label-width="120px"
        >
        <el-form-item label="当前节点" v-if="title === 2">
            {{pidTreeData.title}}
        </el-form-item>
        <!-- 商户选品 4 -->
        <el-form-item label="id" prop="id" v-if="type === 4">
            <el-input style="width: 80%" v-model="ruleForm.id" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="分类名称" prop="classificationName" v-if="type === 4">
            <el-input style="width: 80%" v-model="ruleForm.classificationName" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <!-- --- -->
        <el-form-item label="appid" prop="appid" v-if="type !== 4">
            <el-input style="width: 80%" v-model="ruleForm.appid" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="菜单名" prop="menuName" v-if="type !== 4">
            <el-input style="width: 80%" v-model="ruleForm.menuName" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <el-form-item label="定金" prop="money" v-if="type === 1 && title !== 1">
            <el-input style="width: 80%" v-model="ruleForm.money" placeholder="请输入" type="number" size="small"></el-input>
        </el-form-item>
        <el-form-item label="跳转类型" v-if="type === 3 && title !== 1">
            <el-radio v-model="ruleForm.jumpType" :label="0">直接跳转</el-radio>
            <el-radio v-model="ruleForm.jumpType" :label="1">携带参数跳转</el-radio>
        </el-form-item>
        <el-form-item label="跳转参数" prop="channel" v-if="type === 3 && title !== 1 && ruleForm.jumpType === 1">
            <el-input style="width: 80%" v-model="ruleForm.channel" placeholder="请输入" size="small"></el-input>
        </el-form-item>
        <!-- 封面 -->
        <el-form-item :label="type === 4 ? '分类图标' : '图标'" prop="icon">
          <el-upload
            class="avatar-uploader"
            :action= upLoadApi
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :headers="uploadHeaders"
            >
            <div class="file-upload">
              <img v-if="ruleForm.icon" :src="ruleForm.icon" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="分类大图" prop="bigIcon" v-if="type === 4">
          <el-upload
            class="avatar-uploader"
            :action= upLoadApi
            :show-file-list="false"
            :on-success="handleBigAvatarSuccess"
            :headers="uploadHeaders"
            >
            <div class="file-upload">
              <img v-if="ruleForm.bigIcon" :src="ruleForm.bigIcon" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="分类广告" prop="advertisementIcon" v-if="type === 4">
          <el-upload
            class="avatar-uploader"
            :action= upLoadApi
            :show-file-list="false"
            :on-success="handleBigAdvertisementIcon"
            :headers="uploadHeaders"
            >
            <div class="file-upload">
              <img v-if="ruleForm.advertisementIcon" :src="ruleForm.advertisementIcon" class="avatar">
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </div>
          </el-upload>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
            <el-input-number v-model="ruleForm.sort" :min="0" size="small"></el-input-number>
        </el-form-item>
        <el-form-item label="分类广告连接" prop="" v-if="type === 4">
            <el-select
                style="width: 80%"
                v-model="ruleForm.advertisement"
                clearable
                size="small"
                placeholder="请选择"
              >
                <el-option
                  v-for="item in advertisementList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value" 
                >
                </el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="是否显示" v-if="type === 4">
            <el-radio v-model="ruleForm.show" :label="0">显示</el-radio>
            <el-radio v-model="ruleForm.show" :label="1">隐藏</el-radio>
        </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleCloseAdd('ruleForm')">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
    </span>
    </el-dialog>
  </div>
</template>

<script>
import serveApi from '../serve.js'
export default {
  props: {
        type: {
            type: Number,
            default() {
                return {}
            }
        }
    },
  data() {
    return {
      // 新增or编辑
      title: '',
      dialogVisible: false,
      // 参数
      ruleForm: {
        id: '',
        appid: '',
        menuName: '',
        icon: '',
        bigIcon: '',
        advertisementIcon: '',
        sort: '',
        classificationName: '',
        money: 0,
        jumpType: 0,
        channel: '',
        show: 0,
      },
      // 规则
      rules: {
        id: { required: true,message: '请填写id',trigger: 'blur' },
        menuName: { required: true,message: '请填写名字',trigger: 'blur' },
        sort: { required: true,message:'请填写排序',trigger: 'blur' },
        money: { required: true, message:'请填写金额',trigger: 'blur' },
        classificationName: { required: true, message:'请填写分类名称',trigger: 'blur' },
        channel: { required: true, message:'请填写携带参数',trigger: 'blur' },
      },
      // 上级节点数据
      pidTreeData: '',
      // 上传地址
      upLoadApi: '',
      // token
      uploadHeaders: {"token":localStorage.getItem('token')},
      // 分类广告连接
      advertisementList: []
    };
  },
  mounted() {
    // 上传地址拼接
    this.upLoadApi = serveApi.api + '/admin/file/upload'
  },
  components: {
  },
  methods: {
    /**
     * 打开弹窗
     */
    openDia(e, item) {
      console.log(item, 'item')
      // e === 1 新增根 || e === 2  添加子节点 || e === 3 编辑
      // this.ruleForm.roleName = item
      this.dialogVisible = true
      this.pidTreeData = item
      this.title = e
      if(e === 3) {
        this.ruleForm.id = this.type === 4 ? item.id : ''
        this.ruleForm.classificationName = this.type === 4 ? item.classificationName : ''
        this.ruleForm.appid = this.type !== 4 ? item.appid : ''
        this.ruleForm.menuName = this.type !== 4 ? item.title : ''
        this.ruleForm.icon = item.icon
        this.ruleForm.sort = item.sort
        this.ruleForm.money = this.type === 1 ? item.money : 0
        this.ruleForm.jumpType = this.type === 3 ? item.jumpType : 0
        this.ruleForm.channel = this.type === 3 && item.jumpType === 1 ? item.channel : ''
      }
    },
    /**
     * 关闭弹窗
     */
    handleCloseAdd(formName) {
      this.$refs[formName].resetFields();
      this.dialogVisible = false
    },

    /**
     * 点击确认
     */
    submitForm(formName) {
      let params = {
        appid: this.ruleForm.appid,
        icon: this.ruleForm.icon,
        id: this.title === 3 ? this.pidTreeData.id : '',
        pid: this.title === 1 ? 0 : this.title === 3 && this.pidTreeData.pid === 0 ? 0 : this.title === 2 ? this.pidTreeData.id : this.pidTreeData.pid,
        sort: this.ruleForm.sort,
        status: 1,
        title: this.ruleForm.menuName,
        type: this.type,
        money: this.type === 1 ? Number(this.ruleForm.money) : 0,
        jumpType: this.type === 3 ? this.ruleForm.jumpType : 0,
        channel: this.type === 3 && this.ruleForm.jumpType === 1 ? this.ruleForm.channel : ''
      }
      this.$api.production.listAddEdit(params).then(res => {
          this.$refs[formName].resetFields()
          this.dialogVisible = false
          this.$emit('getList')
      })
    },
    /**
     * 图标上传
     */
    handleAvatarSuccess(res, file) {
      this.ruleForm.icon = res.data  
    },
    /**
     * 分类大图
     */
    handleBigAvatarSuccess(res, file) {
      this.ruleForm.bigIcon = res.data  
    },
    /**
     * 分类广告
     */
    handleBigAdvertisementIcon(res, file) {
      this.ruleForm.advertisementIcon = res.data  
    }
  }
};
</script>

<style  scoped>
.avatar {
  width: 150px;
  height: 100px;
  display: block;
}
.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 100px;
  line-height: 100px;
  border: 1px dashed #aaa;
  text-align: center;
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/productTypeDialog.vue